import aboutThunk from './about';
import contactUsThunk from './contact-us';
import fileThunk from './file';
import prematterThunk from './prematter';
import sessionThunk from './session';
import userThunk from './user';
import websocketThunk from './websocket';
import lawyerConnectionThunk from './lawyer-connection';


export default {
  aboutThunk,
  contactUsThunk,
  fileThunk,
  prematterThunk,
  sessionThunk,
  userThunk,
  websocketThunk,
  lawyerConnectionThunk,
};
